export const initialState = {
    applicationConfig:{},
    rejectedReasons:[],
    getStandardGoUrls:{},
    featureFlags:[]
};

const AppReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_APPLICATION_CONFIG':{
            return  {
                ...state,
                applicationConfig:action.value
            }
        }
        case 'SET_REJECTION_REASONS':{
            return  {
                ...state,
                rejectedReasons:action.value
            }
        }
        case 'SET_AGREEMENT_REJECTION_REASONS':{
            return  {
                ...state,
                rejectedAgreementReasons:action.value
            }
        }
        case 'SET_STANDARD_GO_URLS':{
            return {
                ...state,
                getStandardGoUrls:action.value
            }
        }
        case 'SET_FEATURE_FLAG' : {
            return {
                ...state,
                featureFlags : action.value
            }
        }
        default:
            return state;
    }

};

export default AppReducer;
